import React from 'react';


// import animate on scroll
import Aos from 'aos';
import 'aos/dist/aos.css';

// import components
import Hero from './components/Hero';
import Aboutasmaul from './components/Aboutasmaul';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import Asmaul from './components/Asmaul';

const Doaharian = () => {
  // animate on scroll initialization
  Aos.init({
    duration: 1800,
    offset: 0,
  });
  return (
    <div className='overflow-hidden'>
      <Hero />
      <Aboutasmaul />
      <Asmaul />
      <CtaSection />
      <Footer />
    </div>
  );
};

export default Doaharian;
